module.exports = __webpack_public_path__ + "static/media/man-reading-primary.b41c8c56.svg";